function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  stroke: "currentcolor",
  fill: "currentcolor",
  strokeWidth: "0",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10 0A9.94 9.94 0 000 10a9.94 9.94 0 0010 10 9.94 9.94 0 0010-10A9.94 9.94 0 0010 0zm3.86 15L10 11.14 6.14 15 5 13.86 8.86 10 5 6.14 6.14 5 10 8.86 13.86 5 15 6.14 11.14 10 15 13.86z"
})));